import feathersClient from "../../feathers-client";

const defaultJobPredictionPagination = {
	total:100,
	$skip:0,
	$limit:4,
};
const defaultJobPredictionPaginationFilter = {
	$skip:defaultJobPredictionPagination.$skip,
	$limit: defaultJobPredictionPagination.$limit
};

export default {
	state:{
		jobPrediction:[],
		JobPredictionPagination:defaultJobPredictionPagination,
		JobPredictionPaginationFilter:defaultJobPredictionPaginationFilter
	},
	getters:{
		setJobPredictionPage:(state) => {
			const {$limit, $skip} = state.JobPredictionPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_JOB_PREDICTION_REASON:(state,data) => {state.jobPrediction = data;},
		SET_JOB_PREDICTION_REASON_PAGINATION:(state, data) => {state.JobPredictionPagination = {...state.JobPredictionPagination, ...data};},
		SET_JOB_PREDICTION_REASON_PAGINATION_FILTER:(state,data) => {state.JobPredictionPaginationFilter  = {...state.JobPredictionPaginationFilter, ...data};}

	},
	actions:{
		setJobPredictionListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.JobPredictionPagination.$limit;
			commit('SET_JOB_PREDICTION_REASON_PAGINATION', { $skip });
			commit('SET_JOB_PREDICTION_REASON_PAGINATION_FILTER', { $skip });
		},

		getJobPrediction: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').find({
				query:{
					// $role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_JOB_PREDICTION_REASON',results.data);
			commit('SET_JOB_PREDICTION_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		createJobPrediction: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').create(data,{
				// query:{
				// 	$role: rootGetters.currentUserRole,
				// }
			});
			return results;
		},
		updateJobPrediction: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').patch(data.id, data,{
				// query:{
				// 	$role: rootGetters.currentUserRole,
				// }
			});
			return results;
		},
		deleteJobPrediction: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').remove(id,{
				// query:{
				// 	$role:rootGetters.currentUserRole,
				// }
			});
			return results;
		},
		getJobPredictionById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').get(id,{
				// query:{
				// 	$role: rootGetters.currentUserRole,
				// }
			});

			return results
		},
		getAllJobPredictionForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').find({
				// query:{
				// 	$role:rootGetters.currentUserRole,

				// }
			});
			return results;
		},
		getAllHiFiAwardsReason: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/job-prediction-configurations').find({
				// query:{
				// 	$role:rootGetters.currentUserRole,
				// }
			});
			return results.data;
		}

	}
}
